import Home from './Home';

export default Home;


// WEBPACK FOOTER //
// ./src/components/pages/Home/index.js